import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

export const OrganizationTabNavigation = () => {
  const pageTabs: PageTabItem[] = [
    {
      label: 'organization:tabNavigation.organizationDetails',
      route: RoutesEnum.Organization,
    },
    {
      label: 'organization:tabNavigation.organizationFee',
      route: RoutesEnum.OrganizationFee,
    },
    {
      label: 'organization:tabNavigation.organizationBoard',
      route: RoutesEnum.OrganizationBoard,
    },
    {
      label: 'organization:tabNavigation.organizationRole',
      route: RoutesEnum.OrganizationRole,
    },
  ];

  return <PageTabNavigation pageTabs={pageTabs} />;
};
